import { format } from 'date-fns';

export function getDateFromState(text: Date | undefined): string {
    if (
        text === null ||
        text === undefined ||
        text.toString() === 'Invalid Date'
    ) {
        return '___';
    }
    return format(text, 'd/M/yyyy');
}
